import { useContext, useEffect, useState, KeyboardEvent } from 'react';
import { isNil } from 'ramda';

import { ifTrue } from 'src/tools/logic.tools';

import { Maybe, UseIcons } from 'src/models';
import { FormParserContext } from 'src/contexts/form.context';

import { InputWithIcons } from 'src/components/Inputs';

import { ALLOWED_TYPES } from 'src/data/users.data';

export function PlainInput() {
  const {
    value,
    onChange,
    onSubmit,
    script,
    error,
    isReadonly,
    readData: initialValue,
  } = useContext(FormParserContext);

  const [isShowPassword, setIsShowPassword] = useState(false);

  const [isModifiedValue, setIsModifiedValue] = useState(false);

  // if value is not modified by user and initial value was changed -> update current value
  useEffect(() => {
    if (!isModifiedValue && !isNil(initialValue) && value !== initialValue) onChange(initialValue);
  }, [initialValue, isModifiedValue, onChange, value]);

  function handleOnRightIconClick() {
    setIsShowPassword(state => !state);
  }

  function handleOnKeyDown(e: KeyboardEvent) {
    if (script.type === 'password' && e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  function handleOnChange(newValue: string) {
    setIsModifiedValue(true);
    onChange(newValue);
  }

  let type = ifTrue(!!script.type && ALLOWED_TYPES.includes(script.type), script.type);

  let rightIconId: Maybe<UseIcons>;

  if (script.type === 'password') {
    rightIconId = ifTrue(isShowPassword, 'visibility-on', 'visibility-off');

    type = ifTrue(isShowPassword, 'text', 'password');
  }

  return (
    <InputWithIcons
      className={ifTrue(error, 'with-error')}
      autoComplete={script.autoComplete}
      autoCorrect={script.autoCorrect}
      autoFocus={script.autofocus}
      onChange={handleOnChange}
      onSubmit={onSubmit}
      placeholder={script.placeholder}
      spellCheck={script.spellCheck}
      type={ifTrue(!!type && ALLOWED_TYPES.includes(type), type)}
      value={value}
      rightIconId={rightIconId}
      onRightIconClick={handleOnRightIconClick}
      isReadonly={isReadonly}
      maxLength={script.max}
      onKeyDown={handleOnKeyDown}
    />
  );
}
